<p class="symptom">
  {{ 'symptomAssessment.selectedSymptom' | translate}}<span>{{ symptomSelected.label }}</span>
</p>
<form [formGroup]="questionnaireForm">
  <div *ngFor="let question of questions; let i = index" class="question-container">
    @if (!question.symptom?.label) {
      <p class="label">{{ question.category || '' }} {{ question.label }}</p>
    }
    @if (question.symptom?.label) {
      <p class="label">{{ question.category || '' }} {{ question.symptom?.label ? '(' + question.symptom.label + ')' : '' }}</p>
    }
    <div *ngIf="question.questions">
      <nz-form-item *ngFor="let subQuestion of question.questions; let j = index">
        <p class="label">
          {{ subQuestion.label }}
          @if (subQuestion.tooltip) {
            <span nz-tooltip class="tooltip" nzTooltipTitle="{{ subQuestion.tooltip }}">
              <i nz-icon nzType="info-circle" nzTheme="outline"></i>
            </span>
          }
        </p>
        <ng-container *ngIf="subQuestion.multiple; else singleChoice">
          <div *ngFor="let answer of subQuestion.answers" class="checkbox-option">
            <nz-form-control>
              <label nz-checkbox [formControl]="getFormControl('question_' + i + '_' + j, answer.code)">
                {{ answer.label }}
              </label>
              @if (answer.tooltip) {
                <span nz-tooltip class="tooltip" nzTooltipTitle="{{ answer.tooltip }}">
                  <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                </span>
              }
            </nz-form-control>
          </div>
        </ng-container>
        <ng-template #singleChoice>
          <nz-radio-group formControlName="question_{{ i }}_{{ j }}" class="radio-group">
            <label *ngFor="let answer of subQuestion.answers" nz-radio [nzValue]="answer.code">
              {{ answer.label }}
              @if (answer.tooltip) {
                <span nz-tooltip class="tooltip" nzTooltipTitle="{{ answer.tooltip }}">
                  <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                </span>
              }
            </label>
          </nz-radio-group>
        </ng-template>
      </nz-form-item>
    </div>
    <div *ngIf="!question.questions && question.answers">
      <ng-container *ngIf="question.multiple; else singleChoiceDirect">
        <nz-form-item *ngFor="let answer of question.answers">
          <nz-form-control>
            <label nz-checkbox [formControl]="getFormControl('question_' + i, answer.code)">
              {{ answer.label }}
            </label>
            @if (answer.tooltip) {
              <span nz-tooltip class="tooltip" nzTooltipTitle="{{ answer.tooltip }}">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
              </span>
            }
          </nz-form-control>
        </nz-form-item>
      </ng-container>
      <ng-template #singleChoiceDirect>
        <nz-radio-group formControlName="question_{{ i }}" class="radio-group">
          <label *ngFor="let answer of question.answers" nz-radio [nzValue]="answer.code">
            {{ answer.label }}
            @if (answer.tooltip) {
              <span nz-tooltip class="tooltip" nzTooltipTitle="{{ answer.tooltip }}">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
              </span>
            }
          </label>
        </nz-radio-group>
      </ng-template>
    </div>
  </div>
</form>
